import React from 'react';
import WhiteLogo from '../resources/black.png';
import YellowLogo from '../resources/yellow.png';
import Menu from './menu/Menu';
import MenuHamburger from './menu/MenuHamburger';
import $ from 'jquery';
import LoadingComponent from '../components/LoadingComponent';
import MenuItem from './menu/MenuItem';

type HeaderState = { top: number; isHoverLogo: boolean; logo: string };

type HeaderProps = {
  loading?: React.RefObject<LoadingComponent | null>;
};

/**
 * Render headers with menu
 */
// eslint-disable-next-line @typescript-eslint/ban-types
export default class Header extends React.Component<HeaderProps, HeaderState> {
  protected header: React.RefObject<HTMLElement>;
  protected menu: React.RefObject<Menu>;
  protected menuIcon = React.createRef<MenuHamburger>();

  private lastScroll = 0;

  constructor(props: HeaderProps) {
    super(props);
    this.header = React.createRef();
    this.menu = React.createRef();
    this.state = { top: 0, isHoverLogo: false, logo: WhiteLogo };
  }

  componentDidMount(): void {
    window.onscroll = () => {
      const h = 100 + this.convertRemToPixels(3);
      const header = this.header.current;
      if (window.scrollY - this.lastScroll > 0 && window.scrollY > h) {
        this.setState({ top: -180 });
        header?.classList.remove('sticky');
      } else if (window.scrollY < h) {
        this.setState({ top: 0 });
      }
      this.lastScroll = window.scrollY;
    };

    $(document).on('keyup', (e) => this.onKeyUp(e));
  }

  convertRemToPixels(rem: number) {
    return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
  }

  onKeyUp(e: JQuery.KeyUpEvent) {
    if (e.key !== 'Escape') return;
    this.menu.current?.close();
  }

  showMenu(): void {
    this.menu.current?.toggle();
  }

  headerToggle(isShow: boolean) {
    const header = this.header.current;
    if (isShow) {
      header?.classList.add('show');
      $('body').addClass('overflow-hidden');
    } else {
      header?.classList.remove('show');
      $('body').removeClass('overflow-hidden');
    }
  }

  /**
   * @returns {JSX.Element}
   */
  render(): JSX.Element {
    return (
      <>
        <header className="header" style={{ top: this.state.top }} ref={this.header}>
          <div className="container">
            <div className="logo">
              <MenuItem
                loading={this.props.loading}
                key=""
                src={this.state.logo}
                title="Kaz."
                url="/"
                onMouseEnter={() => this.setState({ logo: YellowLogo })}
                onMouseLeave={() => this.setState({ logo: WhiteLogo })}
                onClick={() => this.menuIcon?.current?.close()}
              />
            </div>
            <Menu
              loading={this.props.loading}
              ref={this.menu}
              onClick={() => this.menuIcon?.current?.close()}
              onChange={(isShow) => this.headerToggle(isShow)}
            />
            <div className="menu-hamburger-container">
              <MenuHamburger onClick={() => this.showMenu()} ref={this.menuIcon} />
            </div>
          </div>
        </header>
      </>
    );
  }
}
